import { useState, useCallback } from "react";

export const useFetchData = (handleLogout) => {
    const [error, setError] = useState('');

    // Check token and logout if needed
    const checkToken = useCallback(() => {
        const user = localStorage.getItem("user");
        if (!user) {
            handleLogout();
            return null;
        }
        return JSON.parse(user)?.token;
    }, [handleLogout]);

    const fetchData = useCallback(async (url, method = "GET", payload = undefined) => {
        const token = checkToken();
        if (!token) return;

        try {
            const headers = {
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`,
            };
            const options = { method, headers };
            if (method !== 'GET' && payload !== undefined) {
                headers['Content-Type'] = 'application/json';
                options.body = JSON.stringify(payload);
            }

            const response = await fetch(url, options);

            if (!response.ok) {
                // Only trigger logout when the check is performed against the auth user endpoint
                const isAuthUserCheck = url.includes("/auth/api/main/user");
                if (isAuthUserCheck && response.status === 401) {
                    handleLogout();
                    return;
                }
                const errorText = await response.text();
                setError(`Failed to fetch data: ${errorText}`);
                throw new Error(errorText);
            }

            return await response.json();
        } catch (err) {
            setError(err.message || 'Error fetching data');
            console.error(err);
            return null;
        }
    }, [checkToken, handleLogout]);

    return { fetchData, error, checkToken };
};
